var getNative = require('./_getNative'),
    root = require('./_root');

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;



//////////////////
// WEBPACK FOOTER
// ./~/victory-stack/~/lodash/_Map.js
// module id = ./node_modules/victory-stack/node_modules/lodash/_Map.js
// module chunks = 1